import Naluri from '~/common/api/naluri';
import CoachAPI from '~/common/api/coachPlatformAPI';
import {
  OVERVIEW_GET_OVERVIEW_DATA_BEGIN,
  OVERVIEW_GET_OVERVIEW_DATA_SUCCESS,
  OVERVIEW_GET_OVERVIEW_DATA_FAILURE,
  OVERVIEW_GET_OVERVIEW_DATA_DISMISS_ERROR,
} from './constants';

// Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
// If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
export function getOverviewData(startDate = null, endDate = null) {
  return dispatch => {
    // optionally you can have getState as the second argument
    dispatch({
      type: OVERVIEW_GET_OVERVIEW_DATA_BEGIN,
    });

    // Return a promise so that you could control UI flow without states in the store.
    // For example: after submit a form, you need to redirect the page to another when succeeds or show some errors message if fails.
    // It's hard to use state to manage it, but returning a promise allows you to easily achieve it.
    // e.g.: handleSubmit() { this.props.actions.submitForm(data).then(()=> {}).catch(() => {}); }
    const overviewPromise = new Promise((resolve, reject) => {
      // doRequest is a placeholder Promise. You should replace it with your own logic.
      // See the real-word example at:  https://github.com/supnate/rekit/blob/master/src/features/home/redux/fetchRedditReactjsList.js
      // args.error here is only for test coverage purpose.
      const url =
        startDate && endDate
          ? `/api/expert/overview?start_date=${startDate}&end_date=${endDate}`
          : `/api/expert/overview`;

      const doRequest = Naluri.get(url);
      doRequest.then(
        res => {
          resolve(res);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        err => {
          dispatch({
            type: OVERVIEW_GET_OVERVIEW_DATA_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    const recommendationAPI = endPoint => {
      return new Promise((resolve, reject) => {
        const doRequest = CoachAPI.get(`/coach-recommendations/${endPoint}`);
        doRequest.then(
          res => {
            const activity_to_respond = {
              data: [],
              total: 0,
            };

            if (res.data) {
              // Inject coach recommendation overview data into existing overview data object
              let coachRes = res.data.recommendations;

              if (Array.isArray(coachRes) && coachRes.length > 0) {
                activity_to_respond.data = coachRes
                  .filter(datum => {
                    return !!datum.channelId && !datum.respondedAt && !datum.skippedAt;
                  })
                  .map(datum => {
                    return {
                      channel_id: datum.channelId,
                      name: datum.memberName,
                      photo: datum.memberPhoto,
                      sponsor: datum.sponsor,
                      type: datum.recommendationType,
                      activity_date: datum.activityDate,
                    };
                  });

                activity_to_respond.total = activity_to_respond.data.length;
                activity_to_respond.data = activity_to_respond.data.splice(0, 10);
              }
            }
            resolve(activity_to_respond);
          },
          // Use rejectHandler as the second argument so that render errors won't be caught.
          err => {
            dispatch({
              type: OVERVIEW_GET_OVERVIEW_DATA_FAILURE,
              data: { error: err },
            });
            reject(err);
          },
        );
      });
    };

    const recommendationPromise = recommendationAPI('recommendations');
    const ambiguousRecommendationPromise = recommendationAPI('recommendations/ambiguous');

    const returnCombinedPromise = Promise.allSettled([
      overviewPromise,
      recommendationPromise,
      ambiguousRecommendationPromise,
    ]).then(res => {
      let combinedOverviewData;

      if (res[0].value) {
        combinedOverviewData = res[0].value;
        combinedOverviewData.summary.activity_to_respond = res[1].value ? res[1].value : null;
        combinedOverviewData.summary.ambiguous_activity = res[2].value ? res[2].value : null;
      }

      if (combinedOverviewData) {
        dispatch({
          type: OVERVIEW_GET_OVERVIEW_DATA_SUCCESS,
          data: combinedOverviewData,
        });
      }
    });

    return returnCombinedPromise;
  };
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissGetOverviewDataError() {
  return {
    type: OVERVIEW_GET_OVERVIEW_DATA_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case OVERVIEW_GET_OVERVIEW_DATA_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        getOverviewDataPending: true,
        getOverviewDataError: null,
      };

    case OVERVIEW_GET_OVERVIEW_DATA_SUCCESS:
      // The request is success

      return {
        ...state,
        ...action.data,
        getOverviewDataPending: false,
        getOverviewDataError: null,
      };

    case OVERVIEW_GET_OVERVIEW_DATA_FAILURE:
      // The request is failed
      return {
        ...state,
        getOverviewDataPending: false,
        getOverviewDataError: action.data.error,
      };

    case OVERVIEW_GET_OVERVIEW_DATA_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        getOverviewDataError: null,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/overview/redux/getOverviewData.js